const tr = {
  reportsEpay: {
    attributes: {
      pin_activated_date: 'Data Ativação PIN',
      person_name: 'Nome pessoa',
      cpf_cnpj: 'CPF/CNPJ Pessoa',
      value: 'Valor (R$)',
      payment_way: 'Forma de Pagamento',
      pin: 'PIN',
      status_nfe: 'Status NFSe',
      epay_reports: 'Relatório Epay',
      epay_reports_description: '',
    },
    extras: {
      date_init: 'Data inicial',
      date_end: 'Data final',
      search: 'Digite o nome ou CPF',
      corporation: 'Empresa',
    },
    defSingular: 'Relatório de usuários ativos por empresa',
  },
};

export default tr;
